module.exports = __webpack_public_path__ + "img/H4.a25059a1.png";